import React, { useState, useEffect } from "react";
import { AxiosResponse, AxiosError } from "axios";
import api from "../axios/axios";
import { UserLoginData } from "../TypeScript/interfaces";
import { useFileUploadInfoData } from "./Contexts/fileUploadInfoProvider";

interface Props {
  setSelectedPage: React.Dispatch<React.SetStateAction<string>>;
  setDisplayBOList: React.Dispatch<React.SetStateAction<boolean>>;
  setUserLoginData: React.Dispatch<React.SetStateAction<UserLoginData>>;
}

const LoginScreen: React.FC<Props> = (props) => {
  const { setSelectedPage, setDisplayBOList, setUserLoginData } = props;
  const emailRef = React.useRef<HTMLInputElement>(null);
  const passwdRef = React.useRef<HTMLInputElement>(null);
  const [wrongLogin, setWrongLogin] = useState(false);
  const [loginFieldError, setLoginFieldError] = useState(false);
  const [loginErrorMessage, setLoginErrorMessage] = useState('');
  const { fileUploadData, setUploadData } = useFileUploadInfoData();
  


  useEffect(() => {
    setDisplayBOList(false);
    setUserLoginData({
      salutation: "",
      firstName: "",
      lastName: "",
      email: "",
      userType: "",
      customerOrg: "",
      phoneNbr: "",
    });
  }, []);

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    const validateEmail = (email: string) => {
      const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      return emailPattern.test(email);
    };
    const validateLogin = (login: string) => {
      const loginPattern = /^([a-zA-Z]{2})([0-9]{3})$/; //AB123 or ab123
      return loginPattern.test(login);
    };

    if (
      validateEmail(emailRef.current?.value as string) ||
      validateLogin(emailRef.current?.value as string)
    ) {
      e.preventDefault();
      setLoginFieldError(false);
      api
        .post("/bol-gui/v1/bol/login", {
          email: emailRef.current?.value,
          passwd: passwdRef.current?.value,
        })
        .then((response: AxiosResponse) => {
          if (response.data.firstName !== "") {
            setUserLoginData({
              salutation: String(response.data.salutation || ""),
              firstName: String(response.data.firstName),
              lastName: String(response.data.lastName),
              email: String(response.data.email),
              userType: String(response.data.userType || ""),
              customerOrg: String(response.data.customerOrg || ""),
              phoneNbr: String(response.data.phoneNbr || ""),
            });
            setSelectedPage("MarketSelection");
            setDisplayBOList(true);
            setUploadData({ returnedError: "" });
          } else {
            setWrongLogin(true);
          }
        })
        .catch((error: AxiosError) => {
          setWrongLogin(true);
          console.log(JSON.stringify(error, null, 2));
          console.log(error.response?.data);
          if (error.response?.status !== 401) {
            setUploadData({ returnedError: "UnexpectedError" });
            setSelectedPage("ErrorPage");
          } else if (error.response?.status === 401) {
            setLoginErrorMessage(error.response?.data as string)
          }
        });
    } else {
      e.preventDefault();
      setLoginFieldError(true);
    }
  };

  return (
    <form onSubmit={onSubmit}>
      <p style={{ fontWeight: "bold" }}>Login</p>
      <div>Login:</div>
      <div>
        <input
          style={{ width: 210 }}
          id="email"
          name="email"
          placeholder=""
          ref={emailRef}
        />
      </div>
      {loginFieldError && (
        <p style={{ color: "red" }}>
          <strong>
            Login must be either valid email or 5 characters in format ab123
          </strong>
        </p>
      )}
      <div>Password:</div>
      <div>
        <input
          style={{ width: 210 }}
          id="password"
          type="password"
          name="password"
          placeholder=""
          ref={passwdRef}
        />
      </div>
      <br />
      <button type="submit"> login</button>
      <br />
      {wrongLogin && (
        <p style={{ color: "red" }}>
          <strong>
            {loginErrorMessage}
          </strong>
        </p>
      )}
      {fileUploadData.returnedError === "user not logged" && (
        <p style={{ color: "red" }}>
          <strong>You have been logged off due to long inactivity.</strong>
        </p>
      )}
    </form>
  );
};

export default LoginScreen;
